import React from 'react';
import { Link, withRouter } from 'react-router-dom';

import {
  DownOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
  LoginOutlined,
  PoweroffOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Avatar, Dropdown, Menu } from 'antd';
import useUserInfo from '@/hooks/useUserInfo';
import { connect } from 'react-redux';
import styles from './Header.module.less';
import logo from '../../components/login/img/onlineMall-logo.png';
import { useFullscreen } from 'ahooks';

function RightHeader(props) {
  const userInfo = useUserInfo();
  const [isFullscreen, { toggleFull }] = useFullscreen(document.documentElement);
  function handleLogout() {
    props.logout();
    props.history.push('/loginOnlineMall');
  }

  const menu = (
    <Menu>
      <Menu.Item title="全屏" onClick={() => toggleFull()}>
        {isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
        <span>{isFullscreen ? '退出全屏' : '全屏'}</span>
      </Menu.Item>
      <Menu.Item title="退出" onClick={handleLogout}>
        <PoweroffOutlined />
        <span>退出</span>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className={styles.header}>
      <Link to="/">
        <img alt="logo" src={logo} height={48} />
      </Link>
      <div className={styles.right}>
        {userInfo.name ? (
          <Dropdown overlay={menu} overlayStyle={{ zIndex: 100, position: 'fixed' }}>
            <div className={styles.dropName}>
              <Avatar size={32} icon={<UserOutlined />} />
              <span className={styles.spanMiddle}>{userInfo.name}</span>
              <DownOutlined className={styles.marginLeft8} />
            </div>
          </Dropdown>
        ) : (
          <Link to="/loginOnlineMall" className={styles.action} title="登录">
            <LoginOutlined />
          </Link>
        )}
      </div>
    </div>
  );
}
const mapDispatchToProps = (dispatch) => ({ logout: dispatch.login.logout });

export default withRouter(connect(null, mapDispatchToProps)(RightHeader));
